var _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEducationDivider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 416,
    height: 1,
    viewBox: "0 0 416 1",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "edu-divider",
    y1: 0.5,
    x2: 416,
    y2: 0.5,
    stroke: "#27272A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationDivider);
export default __webpack_public_path__ + "static/media/education-divider.053672d7112f4628078cef3c6571f4a4.svg";
export { ForwardRef as ReactComponent };